import { useContext } from 'react'

import AuthSupplierContext from 'contexts/AuthSupplierContext'

const useAuthSupplier = () => {
  const context = useContext(AuthSupplierContext)

  if (context === undefined) {
    throw new Error(
      'useAuthSupplier must be used within a AuthSupplierContext.Provider',
    )
  }

  return {
    company: context.company,
    companySupplier: context.companySupplier,
    homeRoute: context.homeRoute,
    isLoading: context.isLoading,
    loadCompanySupplier: context.loadCompanySupplier,
    loadData: context.loadData,
    loadDataWithAnimation: context.loadDataWithAnimation,
    loaded: context.loaded,
    loadOut: context.loadOut,
    loadSupplier: context.loadSupplier,
    loadUser: context.loadUser,
    mixpanelBrowser: context.mixpanelBrowser,
    permissions: context.permissions,
    refresh: context.refresh,
    setCompany: context.setCompany,
    setCompanySupplier: context.setCompanySupplier,
    setIsLoading: context.setIsLoading,
    setUser: context.setUser,
    supplier: context.supplier,
    user: context.user,
  }
}

export default useAuthSupplier
